import { useMemo, useRef } from 'react';
import ReactSelect from 'react-select';
import { PulseLoader } from 'react-spinners';
import { css } from 'styled-components';
import { primaryColor } from '../../config/colors';

import { ArrowsWrapper, ArrowUp, ArrowDown, stylesByDesign } from './styles';

const noneOption = { value: null, label: 'None' };

const Dropdown = ({
  options = [],
  value = null,
  placeholder = '',
  externalStyles = {},
  maxMenuHeight = 180,
  isOptional = false,
  isLoading = false,
  isDisabled = false,
  onChange = () => undefined,
}) => {
  const ref = useRef(null);

  let styles = {
      ...stylesByDesign,
      ...externalStyles,
    };
  const allOptions = isOptional ? [noneOption, ...options] : options;
  const valueOption = allOptions.find((option) => option.value === value) ?? undefined;

  return (
    <ReactSelect
      isLoading={isLoading}
      ref={ref}
      options={allOptions}
      value={valueOption}
      placeholder={placeholder}
      maxMenuHeight={maxMenuHeight}
      styles={styles}
      menuPlacement={'auto'}
      components={{
        DropdownIndicator: DropdownIndicator,
        IndicatorSeparator: () => null,
        LoadingIndicator: LoadingIndicator,
      }}
      onChange={(newOption) => onChange({ label: newOption.label, value: newOption.value })}
      isDisabled={isDisabled}
    />
  );
};

const DropdownIndicator = (props) => (
  <ArrowsWrapper {...props}>
    <ArrowUp />
    <ArrowDown />
  </ArrowsWrapper>
);

const LoadingIndicator = (props) => {
  return (
    <PulseLoader
      {...props}
      size={10}
      color={primaryColor}
      delay={0}
      css={css`
        margin-right: 10px; ;
      `}
    />
  );
};

export default Dropdown;
